import classNames from 'classnames';
import { AnimatePresence, m as motion } from 'framer-motion';
import DeleteSVG from 'public/icons/bin.svg';
import DownloadSVG from 'public/icons/download.svg';
import PdfSVG from 'public/icons/pdf.svg';
import ReactDOM from 'react-dom';
import { TransformedCard } from '@/shared/api/lib/utils/transform-program';
import { createPdf } from '@/shared/api/postFavouritesPrograms';
import { useFavoriteProgramsSetState, useFavoriteProgramsValue } from '@/shared/atoms/favorite-programm';
import { useFavoriteWindowStateValue } from '@/shared/atoms/favorite-window';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import Button from '../Button';

interface Props {
    favorites: TransformedCard[];
    pdfTheme?: string;
    pdfTitle?: string;
}

function FavoriteWindowContent({ favorites, pdfTheme, pdfTitle }: Props) {
    const isShow = useFavoriteWindowStateValue();
    const device = useMediaQueryDeviceStateValue();
    const isMobile = device.includes('mobile');
    const favoritesAtom = useFavoriteProgramsValue();
    const setNullFavorites = useFavoriteProgramsSetState();

    return (
        <AnimatePresence>
            {favoritesAtom.length > 0 && isShow && (
                <motion.div
                    exit={{ opacity: 0, y: 100, x: isMobile ? 0 : '-50%' }}
                    initial={{ opacity: 0, y: 100, x: isMobile ? 0 : '-50%' }}
                    animate={{ opacity: 1, y: 0, x: isMobile ? 0 : '-50%' }}
                    className="favorite-window"
                >
                    <div className="favorite-window-top">
                        <div className="favorite-window-count text-xs">
                            {isMobile ? 'Кол-во избранного:' : 'Количество избранного:  '} {favoritesAtom.length}
                        </div>
                        <button
                            className="favorite-window-delete-btn"
                            onClick={() => {
                                if (favorites.length > 0) {
                                    setNullFavorites([]);
                                }
                            }}
                        >
                            <div className="favorite-window-delete-btn-text text-xs">Удалить все</div>
                            <DeleteSVG />
                        </button>
                    </div>
                    <Button
                        className={classNames('favorite-window-download-btn js-favorite-window-download-btn')}
                        onClick={() => {
                            createPdf(favorites, { title: pdfTitle || '', theme: pdfTheme || '' });
                        }}
                    >
                        <div className="presentation-btn-left">
                            <PdfSVG className="pdf-svg" />
                            <div className="text-xs">Сохранить избранное</div>
                        </div>
                        <div className="download-loader-wrapper">
                            <div className="download-loader"></div>
                        </div>
                        <DownloadSVG className="download-svg" />
                        <div className="presentation-btn-error text-xs">Что то пошло не так</div>
                    </Button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

function FavoriteWindow({ favorites, pdfTheme, pdfTitle }: Props) {
    const portalRoot = typeof window !== 'undefined' ? document.querySelector('#modal-root') : null;

    if (!portalRoot) {
        return null;
    }

    return ReactDOM.createPortal(
        <FavoriteWindowContent favorites={favorites} pdfTheme={pdfTheme} pdfTitle={pdfTitle} />,
        portalRoot,
    );
}

export default FavoriteWindow;
